import {GenericError} from './Error';
import {GenericHeader} from './GenericHeader';

export const GenericErrorPage = () => {
  return (
    <>
      <GenericHeader />
      <GenericError />
    </>
  );
};
